import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Chat from './pages/Chat/chat';
import MsgChat from './pages/Msg/msgChat';
import MyQr from './pages/Msg/myQr';
import RoomChat from './pages/Msg/roomChat';
import JoinLanding from './pages/Invite/joinLanding';
import MemberChat from './pages/Invite/memberChat';
import Employee from './pages/Employee/employee';
import Wifi from './pages/Settings/wifi';
import Map from './pages/Map/map';
import Theme from './pages/Settings/theme';
import GenerateCode from './pages/Settings/generateCode';
import Profile from './pages/Settings/profile';
import { BuildingProvider } from './context/BuildingContext';
import { MessageProvider } from './context/MessageContext';
import { AuthProvider } from './context/AuthContext';
import PrivateRoutes, { RequireRole } from './utils/router/privateRoutes';
// WEB-28: ярлык установленного приложения ведёт сюда, а не в чат участника.
import StartRoute from './utils/router/startRoute';

const router = createBrowserRouter([
  {
    path: '/',
    element: <StartRoute />,
  },
  {
    // QR-1b: публичный лендинг приглашения /j/#<token> — ВНЕ PrivateRoutes
    // (приглашённый без сессии; AuthProvider на /j/ mount-вызов /me пропускает,
    // preview идёт отдельным axios без интерсепторов ЛК)
    path: 'j',
    element: <JoinLanding />,
  },
  {
    // QR-3: чат участника в браузере — тоже ВНЕ PrivateRoutes. Объявлен
    // ОТДЕЛЬНОЙ веткой, а не ребёнком 'j': у лендинга нет <Outlet/>, и
    // вложенный маршрут просто не отрисовался бы.
    path: 'j/chat',
    element: <MemberChat />,
  },
  {
    element: <PrivateRoutes />,
    children: [
      {
        path: 'chat/:id',
        element: (
          <MessageProvider>
            <Chat />
          </MessageProvider>
        ),
      },
      // MSG-7: E2E-чат с сотрудником; сама страница гейтится по messengerV2
      // из /me (флаг off -> «Чат недоступен», ссылок на неё тоже нет)
      { path: 'msg/:userId', element: <MsgChat /> },
      // QR-1b: «Мой QR» (гейт msgInvites из /me) и чат с участником по
      // приглашению — та же страница чата, визави member (ensure {member_id}).
      // Порядок важен: 'msg/invite' и 'msg/m/:memberId' объявлены РЯДОМ с
      // 'msg/:userId' — react-router ранжирует статические сегменты выше
      // динамических, /msg/invite не уедет в :userId.
      { path: 'msg/invite', element: <MyQr /> },
      // QR-2 В2: общая комната. Статический сегмент — как и 'msg/invite',
      // объявлен рядом с 'msg/:userId', чтобы не уехать в :userId. Гейт —
      // msgRooms из /me (флаг off -> «Общий чат недоступен», ссылок нет).
      { path: 'msg/room', element: <RoomChat /> },
      { path: 'msg/m/:memberId', element: <MsgChat /> },
      { path: 'map/:id', element: <Map /> },
      { path: 'employee/:id', element: <Employee /> },
      { path: 'settings/theme', element: <Theme /> },
      { path: 'settings/profile', element: <Profile /> },
      {
        // WEB-2: админ-маршруты за роль-гейтом (UX; сервер авторизует по БД)
        element: <RequireRole role="admin" />,
        children: [
          { path: 'settings/wifi', element: <Wifi /> },
          { path: 'settings/generate-code', element: <GenerateCode /> },
        ],
      },
    ],
  },
]);

function App() {
  return (
    <BuildingProvider>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </BuildingProvider>
  );
}

export default App;
